import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext(null);

const LANG_STORAGE_KEY = 'lang'; // 'tr' | 'en'

const readStoredLang = () => {
  const v = localStorage.getItem(LANG_STORAGE_KEY);
  return v === 'tr' || v === 'en' ? v : null;
};

const getBrowserLang = () => {
  const lang = (navigator.language || 'tr').toLowerCase();
  return lang.startsWith('en') ? 'en' : 'tr';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => readStoredLang() ?? getBrowserLang());

  useEffect(() => {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  }, [lang]);

  const toggleLang = () => setLang((prev) => (prev === 'tr' ? 'en' : 'tr'));

  const value = useMemo(
    () => ({
      lang,
      isEnglish: lang === 'en',
      toggleLang,
      setLang,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
};

